import type { FC } from 'react';
import { Button, Card, Flex, Typography } from 'antd';
import {
  LeftOutlined,
  RightOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import type { FailingSiteRowViewModel } from '../../ScorecardPage.types';
import { EvimoTable } from '~/app/components/common/EvimoTable/EvimoTable';

const { Text, Title } = Typography;

export interface FailingSitesTableCardProps {
  title: string;
  urgentNote: string;
  columns: ColumnsType<FailingSiteRowViewModel>;
  rows: FailingSiteRowViewModel[];
  showingLabel: string;
  pageLabel: string;
  prevPageAriaLabel: string;
  nextPageAriaLabel: string;
  page: number;
  pageCount: number;
  onPageChange: (page: number) => void;
}

export const FailingSitesTableCard: FC<FailingSitesTableCardProps> = ({
  title,
  urgentNote,
  columns,
  rows,
  showingLabel,
  pageLabel,
  prevPageAriaLabel,
  nextPageAriaLabel,
  page,
  pageCount,
  onPageChange,
}) => {
  return (
    <Card className="om-section-card" styles={{ body: { padding: 24 } }}>
      <Flex vertical gap={16}>
        <Flex justify="space-between" align="center" gap={12} wrap="wrap">
          <Title level={5} className="ds-section-header" style={{ margin: 0 }}>
            {title}
          </Title>
          <Flex align="center" gap={6} className="scorecard-urgent-note">
            <WarningOutlined aria-hidden />
            <Text type="secondary">{urgentNote}</Text>
          </Flex>
        </Flex>

        <EvimoTable
          className="ds-table om-portfolio-table"
          columns={columns}
          dataSource={rows}
          rowKey="id"
          pagination={false}
          size="middle"
        />

        <Flex justify="space-between" align="center" wrap="wrap" gap={12}>
          <Text type="secondary">{showingLabel}</Text>
          <Flex align="center" gap={8}>
            <Text type="secondary">{pageLabel}</Text>
            <Button
              type="text"
              icon={<LeftOutlined />}
              disabled={page <= 1}
              onClick={() => onPageChange(page - 1)}
              aria-label={prevPageAriaLabel}
            />
            <Button
              type="text"
              icon={<RightOutlined />}
              disabled={page >= pageCount}
              onClick={() => onPageChange(page + 1)}
              aria-label={nextPageAriaLabel}
            />
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
};
